import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const Audits = lazy(() => import('./index'))

const auditsRoutes = [
    {
        path: '/audits',
        component: Audits,
        auth: authRoleAccess.audit_view,
    },
]

export default auditsRoutes
